import { Link } from "react-router-dom";
import { LegalLayout, Clause, Bi, BiList, ORG_NAME } from "./LegalLayout";

export default function CookiePolicyPage() {
  return (
    <LegalLayout
      title="Cookie Policy"
      titleBn="কুকি নীতিমালা"
      intro={
        <Bi
          en={
            <>
              This Cookie Policy explains how {ORG_NAME} uses cookies and similar technologies on our
              website and applications. It should be read together with our{" "}
              <Link to="/privacy-policy" className="text-primary underline underline-offset-2">Privacy Policy</Link>.
            </>
          }
          bn={
            <>
              এই কুকি নীতিমালায় {ORG_NAME} আমাদের ওয়েবসাইট ও অ্যাপ্লিকেশনে কীভাবে কুকিজ ও অনুরূপ প্রযুক্তি
              ব্যবহার করে তা ব্যাখ্যা করা হয়েছে। এটি আমাদের{" "}
              <Link to="/privacy-policy" className="text-primary underline underline-offset-2">প্রাইভেসি নীতিমালার</Link>{" "}
              সাথে একত্রে পাঠ্য।
            </>
          }
        />
      }
    >
      <Clause n="1" title="What Are Cookies?" titleBn="কুকিজ কী?">
        <Bi
          en={
            <>
              Cookies are small text files stored on your device when you visit a website. They help
              the site work, remember your preferences and keep you securely signed in.
            </>
          }
          bn={
            <>
              কুকিজ হলো ছোট টেক্সট ফাইল যা কোনো ওয়েবসাইট ভিজিট করার সময় আপনার ডিভাইসে সংরক্ষিত হয়। এগুলো
              সাইট চালু রাখতে, আপনার পছন্দ মনে রাখতে এবং আপনাকে নিরাপদে সাইন-ইন রাখতে সাহায্য করে।
            </>
          }
        />
      </Clause>

      <Clause n="2" title="How We Use Cookies" titleBn="আমরা কীভাবে কুকিজ ব্যবহার করি">
        <BiList
          items={[
            [
              "Essential cookies: required to sign you in, keep your session secure, and process purchases. The Platform cannot function without these.",
              "অত্যাবশ্যক কুকিজ: আপনাকে সাইন-ইন করাতে, সেশন নিরাপদ রাখতে ও ক্রয় প্রক্রিয়া করতে প্রয়োজনীয়। এগুলো ছাড়া প্ল্যাটফর্ম কাজ করে না।",
            ],
            [
              "Preference cookies: remember settings such as your language or display choices.",
              "পছন্দ কুকিজ: ভাষা বা প্রদর্শন পছন্দের মতো সেটিংস মনে রাখে।",
            ],
            [
              "Analytics cookies: help us understand how the Platform is used so we can improve it. These are used in aggregate and do not identify you personally.",
              "অ্যানালিটিক্স কুকিজ: প্ল্যাটফর্ম কীভাবে ব্যবহৃত হয় তা বুঝতে ও উন্নত করতে সাহায্য করে। এগুলো সমষ্টিগতভাবে ব্যবহৃত হয় এবং আপনাকে ব্যক্তিগতভাবে শনাক্ত করে না।",
            ],
          ]}
        />
      </Clause>

      <Clause n="3" title="Managing Cookies" titleBn="কুকিজ পরিচালনা">
        <Bi
          en={
            <>
              You can control or delete cookies through your browser settings. Please note that
              disabling essential cookies will prevent you from signing in or completing purchases,
              and some features may not work correctly.
            </>
          }
          bn={
            <>
              আপনি আপনার ব্রাউজার সেটিংসের মাধ্যমে কুকিজ নিয়ন্ত্রণ বা মুছে ফেলতে পারেন। তবে খেয়াল রাখুন,
              অত্যাবশ্যক কুকিজ নিষ্ক্রিয় করলে আপনি সাইন-ইন বা ক্রয় সম্পন্ন করতে পারবেন না এবং কিছু ফিচার সঠিকভাবে
              কাজ নাও করতে পারে।
            </>
          }
        />
      </Clause>

      <Clause n="4" title="Third-Party Cookies" titleBn="তৃতীয় পক্ষের কুকিজ">
        <Bi
          en={
            <>
              Some cookies may be set by trusted third parties that support our service, such as our
              payment provider during checkout. Their use of cookies is governed by their own
              policies.
            </>
          }
          bn={
            <>
              আমাদের সেবায় সহায়তাকারী কিছু বিশ্বস্ত তৃতীয় পক্ষ, যেমন চেকআউটের সময় আমাদের পেমেন্ট প্রদানকারী,
              কিছু কুকিজ সেট করতে পারে। তাদের কুকিজ ব্যবহার তাদের নিজস্ব নীতিমালা দ্বারা পরিচালিত হয়।
            </>
          }
        />
      </Clause>

      <Clause n="5" title="Updates" titleBn="হালনাগাদ">
        <Bi
          en={<>We may update this Cookie Policy from time to time. The latest version will always be available on this page.</>}
          bn={<>আমরা সময়ে সময়ে এই কুকি নীতিমালা হালনাগাদ করতে পারি। সর্বশেষ সংস্করণ সর্বদা এই পৃষ্ঠায় পাওয়া যাবে।</>}
        />
      </Clause>
    </LegalLayout>
  );
}
